import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { PaymentPlanEnum } from "@/pages/CreateCampaign/shared/config";

// // 缓存配置
// const CACHE_CONFIG = {
//   MAX_CAMPAIGNS: 10, // 最多保存的活动数量
//   EXPIRY_DAYS: 1,    // 数据过期天数
// };

type TenantStore = {
  paymentPlan: {
    isYear: boolean;
    type: PaymentPlanEnum;
  };
  setPaymentPlan: (paymentPlan: {
    isYear: boolean;
    type: PaymentPlanEnum;
  }) => void;
};

export const useTenantStore = create<TenantStore>()(
  persist(
    (set, get) => ({
      paymentPlan: {
        isYear: false,
        type: PaymentPlanEnum.PAY_AS_YOU_GO,
      },
      setPaymentPlan: (paymentPlan: {
        isYear: boolean;
        type: PaymentPlanEnum;
      }) => set({ paymentPlan }),
    }),
    {
      name: 'tenant-storage',
    }
  )
);
